
    <div class="uk-child-width-1-1@s" uk-grid>
        <div>
            <div class="uk-background-cover uk-height-large uk-panel uk-flex-center uk-flex-middle"
                style="background-image: url(../../assets/homeee4.png);">
                <div class="uk-section uk-light">
                    <div class="uk-container-small uk-width-2xlarge" style="padding-top: 30px;">
                        <div><h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical"  style="margin-bottom: 10px;"> Cake PHP Application Development</h1></div>
                        <div>

                            <p class="uk-padding-large uk-text-left  uk-padding-remove-vertical" style= "font-size: 20px;">PHP  has a tremendous capability
                                to create rich & vibrant web applications. Our team understands the potential of PHP & creates
                                mesmerising web app. </p>

                           

                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="uk-section uk-padding" style=" padding-bottom: 0px;">
        <div class="uk-container">
          
              <h2 class="uk-text-center" style="font-weight: 600;">Developing the Right Application in Php for your Business</h2>
              <br>
              <div class="uk-column-1-2@s">
      
                  
                  <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">
                    At WebSoulLabs, we integrate innovation with technology to produce futuristic web 
                    development website services for your various business requirements. If you are looking
                     for cost-effective and custom web application development services with a quick turnaround
                      time, then we will be best choice. Our experienced team of developers will provide
                       mind-blowing web development services tailored exclusively to your requirements.
                        Our team takes special care to make sure the solutions we provide are elegant and
                         compelling.</p>
                      <p class="uk-text-medium uk-text-justify" style="font-size: 18px;"> Our website
                         design and development team is keen to make exhilarating websites that would capture a user's attention
                          at the very first glance. Our proven strategies in web development services will help you get an
                           impressive boost in website traffic. We analyze each element's placement from a typical user's 
                           perspective and work to improve user interaction with the website.Being a leading web development
                            agency in India, our best practices in web development services will maximize user interactions
                             and revenue generation on your website.
</p>
                      <img data-src="assets/img/php/p1.png" width="700" height="700" alt="" uk-img>
      
              </div>
        </div>
    
        <h2 class="uk-text-center" style="font-weight: 600;">Advantages of PHP Application Development</h2> 
        <br>
        
        <div class="uk-column-1-2@s">
            
           <img data-src="assets/img/php/p3.jpg" width="600" height="700" alt="php" uk-img>
            <ul class="bullet uk-text-medium uk-text-justify"><br>
                <li>Low development and maintenance cost with very high performance and reliability.
                </li>
                <li>PHP is considered one of the easiest scripting languages.
                </li>
                <li>PHP is highly flexible whether it is during an ongoing project or after completing the project.
                </li>
                <li>It gives web developer more control and it is widely used all over the world.</li>
                <li>This platform is quite fast and considered as the best option for building dynamic web pages.</li>
                <li>PHP is an affordable option for getting responsive sites built quickly.</li>
            </ul>
            
         
        
           
            
        </div>
        <h1 class="uk-text-center">Related Services</h1>
        <br>
       <div class="uk-container">
    <div class="uk-grid-small uk-child-width-1-2@s  uk-child-width-1-4@m  uk-flex-center uk-grid-match" uk-grid>
        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
               
                <img class=" uk-align-center" src="assets/icons/cbg11.png" width="100" height="100" alt="">
                <H4 class="uk-text-center" style="font-weight:600">Custom Business<br> Application</H4>
        
            </div>
        </div>
       

        <div>
       
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                <img class=" uk-align-center" src="assets/icons/phpg5.png" width="100" height="100" alt="">
                <H4 class="uk-text-center" style="font-weight:600">Php Application<br> Development</H4>

           
             </div>
       </div>


        <div>
       
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                <img class=" uk-align-center" src="assets/icons/laravelg6.png" width="100" height="100"
                    alt="">
                <H4 class="uk-text-center" style="font-weight:600">Laraval Application<br> Development</H4>

          
        </div>
    </div>

    <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                <img class=" uk-align-center" src="assets/icons/cakeg8.png" width="100" height="100" alt="">
                <H4 class="uk-text-center" style="font-weight:600">CakePhp Application Development</H4>

          
        </div>
    </div>

    <div>
       
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                <img class="uk-align-center" src="assets/icons/pythong4.png" width="100" height="100" alt="">
                <H4 class="uk-text-center" style="font-weight:600">Python Programming </H4>

           
        </div>
    </div>

    <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                <img class=" uk-align-center" src="assets/icons/shopifyg7.png" width="100" height="100" alt="">
                <H4 class="uk-text-center" style="font-weight:600">Ecommerce Web Development</H4>

           
        </div>
    </div>

       
    <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                <img class="uk-align-center" src="assets/icons/webdesigng12.png" width="100" height="100" alt="">
                <H4 class="uk-text-center" style="font-weight:600">Web Design And Development</H4>

            </div>
        </div>
       
    </div>

</div>
        </div>
        <br>
        <br>

        <h1 class="uk-text-center">Technology Stack</h1>
<br>
<div class="uk-container">
    <div class=" wss uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/word.png" style="width:100px; height:100px"
                    alt="border-circle">
                <h4>WordPress</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/angular.png" style="width:100px; height:100px"
                    alt="border-circle">
                <h4>Angular js</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/post.png" style="width:100px; height:100px"
                    alt="border-circle">
                <h4>Postgres SQL</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/html.png"style="width:100px; height:100px"
                    alt="border-circle">
                <h4>Html</h4>
            </div>
        </div>
    </div>
    <div class="wss uk-child-width-1-4@s uk-margin-large uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/css.png" style="width:100px; height:100px"
                    alt="border-circle">
                <h4>CSS</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/rediss.jpg" style="width:100px; height:100px"
                    alt="border-circle">
                <h4>Redis</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/js.jpg" style="width:100px; height:100px"
                    alt="border-circle">
                <h4>JavaScript</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/jest.png" style="width:100px; height:100px"
                    alt="border-circle">
                <h4>Jest</h4>
            </div>
        </div>
    </div>
    <div class="wss uk-child-width-1-4@s uk-margin-large uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/redux.png" style="width:100px; height:100px"
                    alt="border-circle">
                <h4>Redux</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/img/php/r.png" style="width:100px; height:100px"
                    alt="border-circle">
                <h4>Ruby On Rails</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/img/php/aws.png" style="width:100px; height:100px"
                    alt="border-circle">
                <h4>AWS</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/img/php/n.png" style="width:100px; height:100px"
                    alt="border-circle">
                <h4>Nginx</h4>
            </div>
        </div>
    </div>
</div>
<br>